import {EnvFaqItemDescriptor} from "../../../../data/descriptor/env/EnvFaqItemDescriptor";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {EnvFaqItemValueObject} from "../../../../data/value-object/env/EnvFaqItemValueObject";
import {EnvFaqItemSearchOption} from "../../../../data/search-option/env/EnvFaqItemSearchOption";
import {SearchIndex} from "../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../ListPageWrapper";
import {EnvFaqItemIO} from "../../../../io/EnvIO";
import {EnvFaqItemDescription} from "../../../../data/description/env/EnvFaqItemDescription";
import ListOption from "../../../ListOption";
import {EnvFaqItemSearchOptionDescription} from "../../../../data/description/env/EnvFaqItemSearchOptionDescription";
import {
    applyEnvFaqItemSearchOption,
    EnvFaqItemSearchOptionField
} from "../../../search-option-field/env/EnvFaqItemSearchOptionField";
import ListOrder from "../../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<EnvFaqItemValueObject[]>([])
    const option = useStatePair<EnvFaqItemSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={EnvFaqItemIO}
                items={items}
                option={option.value}
                index={index}
                description={EnvFaqItemDescription}
                descriptor={EnvFaqItemDescriptor}
                showPost
                onPostClick={() => document.location = '/env/faqs/items/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/env/faqs/items/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={EnvFaqItemSearchOptionDescription}
                fields={EnvFaqItemSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyEnvFaqItemSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={EnvFaqItemDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}